import type { InvalidatePlaybookBuilderQueriesParams } from './types';

const invalidatePlaybookBuilderQueries = ({
    queryClient,
    playbookId,
}: InvalidatePlaybookBuilderQueriesParams): void => {
    queryClient.invalidateQueries(`admin-playbook-${playbookId}`);
    queryClient.invalidateQueries(`admin-playbook-versions-${playbookId}`);
};

export default invalidatePlaybookBuilderQueries;
